import { ButtonIcon } from '@arvoreeducacao/bonsai-ds'
import React from 'react'
import { Container } from './Header.styles'
import * as playerActions from 'context/player/reducer/player.actions'
import { usePlayerContext } from 'context/player'
import { useFeatureToggles } from 'utils/hooks/use-feature-toggles/useFeatureToggles'
import { useTranslation } from 'i18n'

const Header = () => {
  const { t } = useTranslation()
  const { dispatch, state } = usePlayerContext()
  const { featureToggles } = useFeatureToggles()

  const handleBack = () => {
    if (
      (featureToggles?.biblionPanel ||
        featureToggles?.biblionGeneral ||
        featureToggles?.seedPrPoc) &&
      state.slug
    ) {
      dispatch(playerActions.close())
      window.location.href = `/app-v2/book/intermediate/${state.slug}`
      return
    }
    if (state.isPreview) {
      dispatch(playerActions.close())
      return
    }
    dispatch(playerActions.minimize())
  }

  return (
    <Container data-testid="player-header">
      <ButtonIcon
        iconName="arrow-left"
        aria-label={t('Voltar')}
        theme={{ type: 'ghost', size: 'large' }}
        onClick={handleBack}
      />
    </Container>
  )
}

export default Header
